import _ from 'lodash';

export const selectPRLoader = (state) => _.get(state, ['propertyLoader'], false);